import { useOutletContext } from "react-router-dom";
import Icon from "../../../../../../../../../assets/icons";
import primaryComponents from "../../../../../../../../../components/primaryComponents";
import styles from "./styles.module.scss";
import { usePolicies } from "./usePolicy";
import ReactQuill from "react-quill";

const Policy = () => {
  const { menuProperties } = useOutletContext();
  const {
    policies,
    setPolicies,
    isEditing,
    isLoadingStorefrontPolicies,
    setIsEditing,
    submitStorefrontPolicies,
  } = usePolicies({ menuProperties });
  return (
    <div className={styles.container}>
      <div className={styles.policiesHeading}>
        <div className="d-flex align-items-center" style={{ gap: 20 }}>
          <img src={Icon.noteOne} alt="" />
          <div>
            <h5>Policies</h5>
            <p>Add your business policies here</p>
          </div>
        </div>
        {isEditing ? (
          <primaryComponents.Button
            classNames="btn btn--primary"
            onClick={submitStorefrontPolicies}
            loadingText={"Saving..."}
            isLoading={isLoadingStorefrontPolicies}
            isDisabled={isLoadingStorefrontPolicies}
          >
            <span>Save</span>
          </primaryComponents.Button>
        ) : (
          <primaryComponents.Button
            classNames="btn btn--primary"
            onClick={() => setIsEditing(true)}
            loadingText={"Saving..."}
            isLoading={isLoadingStorefrontPolicies}
            isDisabled={isLoadingStorefrontPolicies}
          >
            <span>Edit</span>
          </primaryComponents.Button>
        )}
      </div>
      {isEditing && (
        <div>
          <ReactQuill
            theme="snow"
            value={policies}
            onChange={(content) => {
              setPolicies(content);
            }}
            placeholder="Add policies to this storefront"
            readOnly={false}
            className={styles.quillEditor}
            modules={{
              toolbar: [
                [{ header: "1" }, { header: "2" }],
                [{ list: "ordered" }, { list: "bullet" }],
                ["bold", "italic", "underline"],
                ["link"],
              ],
            }}
            formats={["header", "list", "bold", "italic", "underline", "link"]}
          />
        </div>
      )}
    </div>
  );
};

export default Policy;
